import { useRef } from "react";
import { PageSection } from "./page-section/page-section";
import pageSectionClasses from "./page-section/page-section.module.sass";
import HeroBlock from "../../components/main-page/hero-block/hero-block";
import Footer from "../../components/common/footer/footer";
import ServicesBlock from "../../components/common/services-block/services-block";
import AwardsBlock from "../../components/main-page/awards-block/awards-block";
import { CasesBlock } from "../../components/main-page/cases-block/cases-block";
import HeroDescription from "../../components/main-page/hero-description/hero-description";
import HeroTextBlock from "../../components/main-page/hero-text-block/hero-text-block";
import {
  STACK_PIN_PRECISE_ATTR,
  STACK_PIN_SKIP_ATTR,
  STACK_PIN_SKIP_VALUE,
  useMainPageStackPin,
} from "./use-main-page-stack-pin";
import "./main-page.sass";

const MainPage = () => {
  const mainPageRef = useRef<HTMLElement>(null);
  const awardsSectionRef = useRef<HTMLElement>(null);
  useMainPageStackPin(mainPageRef, awardsSectionRef);

  return (
    <main className="main-page" ref={mainPageRef}>
      <PageSection>
        <HeroBlock />
      </PageSection>
      <PageSection>
        <HeroTextBlock />
      </PageSection>
      <PageSection>
        <ServicesBlock />
      </PageSection>
      <PageSection
        className={pageSectionClasses.section_cases}
        {...{ [STACK_PIN_SKIP_ATTR]: STACK_PIN_SKIP_VALUE }}
      >
        <CasesBlock />
      </PageSection>
      <PageSection
        className={pageSectionClasses.section_hero_description}
        {...{ [STACK_PIN_PRECISE_ATTR]: "" }}
      >
        <HeroDescription />
      </PageSection>
      <PageSection
        ref={awardsSectionRef}
        className={`${pageSectionClasses.section_awards} awards-section`}
      >
        <AwardsBlock />
      </PageSection>
      <PageSection>
        <Footer />
      </PageSection>
    </main>
  );
};

export default MainPage;
